var map = {
	"./base-comp.vue": "1fa4",
	"./chat/conversation.vue": "e7f1",
	"./chat/loading.vue": "0310",
	"./chat/send-message.vue": "c467",
	"./chat/wrapper.vue": "2e2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2647";